import {
  COUPON_CATEGORY,
  COUPON_VALIDATION,
  DISCOUNT_TYPES,
} from "constants/coupons";
import { createEmptyCurrencySettingsEntry } from "helpers/couponDiscountType";

export const AMOUNT_INPUT_PATTERN = /^\d*\.?\d{0,2}$/;

export const STEP_BY_FIELD = {
  verticalId: 1,
  tenantIds: 1,
  currencyId: 1,
  discountType: 1,
  code: 1,
  category: 1,
  remarks: 1,
  effectiveDate: 2,
  expiryDate: 2,
  discountValue: 3,
  maxAllowedAmount: 3,
  currencySettings: 3,
  minimumPackageMrp: 3,
  minimumCartMrp: 3,
  totalCouponCount: 4,
  isApplicableMultipleTimes: 4,
  isApplicableForSingleUser: 4,
  uamId: 4,
  selectAllPackages: 5,
  packageIds: 5,
  selectAllPlatforms: 6,
  platformIds: 6,
};

export const getTotalCouponCountMinError = () =>
  "Coupon count must be greater than 0.";

export const isPercentageDiscountOverMax = (value, discountType) => {
  if (discountType !== DISCOUNT_TYPES.PERCENTAGE || value === "") {
    return false;
  }

  const numericValue = Number(value);
  return (
    !Number.isNaN(numericValue) &&
    numericValue > COUPON_VALIDATION.MAX_PERCENTAGE_DISCOUNT
  );
};

const resetDiscountDependentFields = (nextValues) => ({
  ...nextValues,
  discountValue: "",
  maxAllowedAmount: "",
  minimumPackageMrp: "",
  minimumCartMrp: "",
  currencySettings: Object.fromEntries(
    Object.keys(nextValues.currencySettings ?? {}).map((currencyId) => [
      currencyId,
      createEmptyCurrencySettingsEntry(),
    ])
  ),
});

export const buildNextValues = (previousValues, field, value) => {
  const nextValues = { ...previousValues, [field]: value };

  if (field === "isApplicableForSingleUser" && value === false) {
    nextValues.uamId = "";
  }

  if (field === "selectAllPackages" && value === true) {
    nextValues.packageIds = [];
  }

  if (field === "selectAllPlatforms" && value === true) {
    nextValues.platformIds = [];
  }

  if (field === "discountType") {
    return resetDiscountDependentFields(nextValues);
  }

  if (field === "minimumCartMrp") {
    const minimumCartMrp = Number(value);
    if (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !Number.isNaN(minimumCartMrp) &&
      minimumCartMrp > COUPON_VALIDATION.MIN_MRP_AMOUNT
    ) {
      nextValues.category = COUPON_CATEGORY.BUNDLE_DISCOUNT;
    }
  }

  return nextValues;
};

export const buildNextCurrencySettingsValues = (
  previousValues,
  currencyId,
  field,
  value
) => {
  const normalizedCurrencyId = String(currencyId ?? "").trim();
  const previousSettings = previousValues.currencySettings ?? {};
  const previousEntry =
    previousSettings[normalizedCurrencyId] ?? createEmptyCurrencySettingsEntry();

  const nextEntry = {
    ...previousEntry,
    [field]: value,
  };

  const nextValues = {
    ...previousValues,
    currencySettings: {
      ...previousSettings,
      [normalizedCurrencyId]: nextEntry,
    },
  };

  if (field === "minimumCartMrp") {
    const minimumCartMrp = Number(value);
    if (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !Number.isNaN(minimumCartMrp) &&
      minimumCartMrp > COUPON_VALIDATION.MIN_MRP_AMOUNT
    ) {
      nextValues.category = COUPON_CATEGORY.BUNDLE_DISCOUNT;
    }
  }

  return nextValues;
};
